import { render, staticRenderFns } from "./open_source_licenses.vue?vue&type=template&id=3a5d1b76&scoped=true"
import script from "./open_source_licenses.vue?vue&type=script&lang=js"
export * from "./open_source_licenses.vue?vue&type=script&lang=js"
import style0 from "./open_source_licenses.vue?vue&type=style&index=0&id=3a5d1b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d1b76",
  null
  
)

export default component.exports